import React from 'react'
import { Footer } from '../components/exports'

export function FooterContainer() {
    return (
        <Footer>
           <Footer.Text>Beerium</Footer.Text>
        </Footer>
    )
}